import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const TriggerWorkflow = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <rect x="3" y="5" width="18" height="6" rx="2" fill={getColor(color, isColorInherited)} />
    <rect x="3" y="16" width="8" height="6" rx="2" fill={getColor(color, isColorInherited)} />
    <rect x="13" y="16" width="8" height="6" rx="2" fill={getColor(color, isColorInherited)} />
    <path d="M7 17V13M17 17V13M12 6V2" stroke={getColor(color, isColorInherited)} strokeWidth="2" />
  </SvgIcon>
);
